import loadable from 'react-loadable';

export default loadable({
    loader: () =>
        import(
            /* webpackChunkName: "board-search-panel" */
            './BoardSearchPanel'
        ),
    loading: () => null,
});
